<template>
  <div class="homepage-content-wrapper">
    <HeroSection :data="heroSection" :heroType="'carousel'" />
    <CompensationSection :data="compensationSection" />
    <BenefitsSection :data="benefitsSection" />
    <CommonSection :data="commonSection" />
    <HelpSection :data="helpSection" />
    <BrandsCrouselSection :data="brandsCrouselSection" />
    <NewsSection :data="newsSection" />
    <CtaSection :data="ctaSection" />
    <FaqSection :data="faqSection" />
  </div>
</template>

<script>
import pageData from '../content/homepage/index';

export default {
  name: 'Home',
  metaInfo: {
    title: 'Home',
  },
  components: {
    HeroSection: () => import('@/components/Homepage/HeroSection.vue'),
    CompensationSection: () =>
      import('@/components/Homepage/CompensationSection.vue'),
    BenefitsSection: () => import('@/components/Homepage/BenefitsSection.vue'),
    CommonSection: () => import('@/components/Homepage/CommonSection.vue'),
    HelpSection: () => import('@/components/Homepage/HelpSection.vue'),
    BrandsCrouselSection: () =>
      import('@/components/Homepage/BrandsCrouselSection.vue'),
    NewsSection: () => import('@/components/Homepage/NewsSection.vue'),
    CtaSection: () => import('@/components/Homepage/CtaSection.vue'),
    FaqSection: () => import('@/components/Homepage/FaqSection.vue'),
  },
  computed: {
    heroSection() {
      return pageData.heroSection;
    },
    compensationSection() {
      return pageData.compensationSection;
    },
    benefitsSection() {
      return pageData.benefitsSection;
    },
    commonSection() {
      return pageData.commonSection;
    },
    helpSection() {
      return pageData.helpSection;
    },
    brandsCrouselSection() {
      return pageData.brandsCrouselSection;
    },
    newsSection() {
      return pageData.newsSection;
    },
    ctaSection() {
      return pageData.ctaSection;
    },
    faqSection() {
      return pageData.faqSection;
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.homepage-content-wrapper
  padding-top: 72px
  @media screen and (max-width: 959px)
    padding-top: 64px
</style>
